module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ms-8f7c204278ae1cdcd35caa2bb55dacc7.svg";